module.exports = __webpack_public_path__ + "img/IMG_1024_L_Black_MockedUp.fd9fa399.jpg";